<template>
    <div class="wlx-site-manager-wrapper">
        <div class="add-partner-enterprise-head clearfix">
            <div class="top-page-top fl">
                <span class="sp-top-text">1+X培训</span>
            </div>
            <div class="fr btn-right">
                <el-form :inline="true" size="small">
                    <el-form-item>
                        <el-input v-model="title" placeholder="培训标题" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" class="el-button-colour" icon="el-icon-search" @click="getPeiXunList()">搜索</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <el-table :data="EnrollList" @selection-change="handleSelectionChange" style="width: 100%">
            <el-table-column prop="Id" type="selection" width="55"></el-table-column>
            <el-table-column type="index" label="序号" width="55"></el-table-column>
            <el-table-column prop="title" label="培训标题" show-overflow-tooltip></el-table-column>
            <el-table-column prop="name" label="姓名" show-overflow-tooltip></el-table-column>
            <el-table-column prop="schoolTitle" label="单位名称" show-overflow-tooltip></el-table-column>
            <!-- <el-table-column prop="address" label="地址" show-overflow-tooltip></el-table-column> -->
            <el-table-column prop="email" label="邮编" show-overflow-tooltip></el-table-column>
            <el-table-column prop="invoice" label="发票抬头" show-overflow-tooltip></el-table-column>
            <el-table-column prop="taxNumber" label="纳税人识别号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="planTime" label="培训时间" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.row.planTime">{{ scope.row.planTime }}</span>
                    <span v-else>---</span>
                </template>
            </el-table-column>
            <el-table-column prop="startDate" label="入住时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="endDate" label="离店时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="dateCreated" label="报名时间" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="goLook(scope.row.id)">编辑</el-button>
                    <!-- <el-button type="primary" size="mini" @click="getSignDetail(scope.row.id)">详情</el-button> -->
                    <!-- <a
            type="primary"
            size="mini"
            :href="exprotHref + scope.row.id"
            class="export-table-btn"
          >导出报名表格</a> -->
                </template>
            </el-table-column>
        </el-table>

        <div class="u-page-con">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="onPageChangeHandler"
                :current-page="page"
                :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
                v-show="totalCount > 0"
                style="text-align: center;"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            title: "",
            EnrollList: [],
            page: 1,
            pageSize: 10,
            totalCount: 0,
            exprotHref: "/api/XOrg/MeetingEnroll/eportMeetingEnroll?MeetingEnrollId=",
        };
    },
    components: {},
    computed: {
        userInfo() {
            return this.$store.state.auth;
        },
    },
    created() {
        this.getPeiXunList();
    },
    props:{
        certificateId:{
            type: String,
            default: ""
        }
    },
    methods: {
        getSignDetail(id) {
            this.$router.push({
                name: "trainSignDetail",
                params: {
                    signUpId: id,
                    certificateId:this.certificateId
                },
            });
        },
        goLook(id) {
            this.$router.push({
                name: "trainSignEdit",
                params: {
                    signUpId: id,
                    certificateId:this.certificateId
                },
            });
        },
        handleSelectionChange() {},
        handleSizeChange(val) {
            this.pageSize = val;
            this.getPeiXunList();
        },
        onPageChangeHandler(val) {
            this.page = val;
            this.getPeiXunList();
        },
        getPeiXunList() {
            var that = this;
            this.$http
                .post("/api/XOrg/PeiXunTea/getPeiXunList", {
                    title: that.title,
                    PageSize: that.pageSize,
                    page: that.page,
                })
                .then((rst) => {
                    if (rst.code > 0) {
                        that.EnrollList = rst.list;
                        that.page = rst.pagination.pageIndex;
                        that.pageSize = rst.pagination.pageSize;
                        that.totalCount = rst.pagination.totalCount;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
    },
};
</script>

<style lang="scss">
.wlx-site-manager-wrapper {
    background: #fff;
    padding-bottom: 20px;
    .add-partner-enterprise-head {
        border-bottom: 1px solid #f0f0f0;
        height: 60px;
        .add-banner-btn,
        .delete-banner-btn {
            margin-top: 13px;
        }
        .delete-banner-btn {
            margin-right: 62px;
        }
        .top-page-top {
            border: none;
        }
    }
    .banner-page-con {
        padding: 20px 0;
        text-align: center;
    }
    .el-table thead {
        color: #05243D;
    }
    .btn-right {
        margin-top: 14px;
    }
    .export-button-a {
        color: #fff;
        background: #05243D;
        padding: 8px 15px;
        border-radius: 4px;
        margin: 0 10px;
    }
}
</style>
